import { jsx as _jsx } from "react/jsx-runtime";
import { ContentImage } from '@coolblue-development/next-image/client';
const Becom = ({ width }) => {
    return (_jsx(ContentImage, { imageId: "589117", width: width, height: width, alt: "WebShop Trustmark", loading: "lazy", objectFit: "scale" }));
};
export default Becom;
//# sourceMappingURL=Becom.js.map